import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MarketingPageComponent } from './marketing-page/marketing-page.component';
import { ConfigPageComponent } from './config-page/config-page.component';
import { PlatformIntegrationsComponent } from './platform-integrations.component';
import { NotFoundComponent } from './common/not-found/not-found';

const routes: Routes = [
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: `:integrationId`,
    component: MarketingPageComponent,
  },
  {
    path: `config/:connectionId`,
    component: ConfigPageComponent,
  },
  {
    path: '',
    component: PlatformIntegrationsComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlatformIntegrationsLibModule {}
